import styled, { css } from 'styled-components'
import { NavLink } from 'react-router-dom'
import { ICentraThemeColors } from 'components/styles/variables'

const globalLinkStyle = () => css<{ size?: string }>`
  ${({ theme, size }) => css`
    text-decoration: underline;
    display: inline-block;
    transition: 0.3s;

    ${size === 'sm' &&
    css`
      font-size: 12px;
      line-height: 1.3;
    `}

    ${theme.breakpoints.down(1023)} {
      font-size: ${size === 'sm' ? '12px' : '14px'};
      line-height: 1.3;
    }

    &:hover {
      text-decoration: none;
    }

    &:disabled {
      cursor: not-allowed;
    }
  `}
`

export const StyledAnchorLink = styled.a<{ size?: 'sm' }>`
  ${globalLinkStyle}
`

export const StyledLink = styled(NavLink)<{ size?: 'sm' }>`
  ${globalLinkStyle}
`

export const StyledButton = styled.button<{ size?: 'sm'; $color?: keyof ICentraThemeColors }>`
  ${globalLinkStyle}

  ${({ theme, $color = 'greySemiDark' }) => css`
    color: ${theme.colors[$color]};

    &:hover {
      color: ${theme.colors.black};
    }
  `}
`
